<template>
	<div>
		<headTop :data="'yes'"></headTop>
		<!-- 领导人谈党史 -->
		<div class="leader wid-1200">
			<div class="leader-t">
<!--				<img src="../assets/images/xjpzsj.png" alt="" class="fl" />-->
				<div class="leader-t-con">
					<h2 class="title title1"></h2>
					<p class="con">
						{{leaderHistoryDetailData.title}}
					</p>
					<p class="tar">-------{{leaderHistoryDetailData.file_path}}</p>
				</div>
			</div>
			<div class="leader-b clearfix">
				<ol class="gx_l_data">
					<li v-for="(item,index) in leaderHistoryData" :key="index">
						<a :href="downloadUrl+item.file_path" target="_blank" :title="item.title"
							>{{item.title}}</a
						>
						<span>{{item.pub_date}}</span>
					</li>
				</ol>
			</div>
		</div>
		<!-- 视频课程 -->
		<div class="video-wrap wid-100">
			<div class="video wid-1200">
				<h2 class="title title2"></h2>
				<div class="video-con clearfix">
					<router-link target="_blank" :to="'/detail/'+videoL.id"  class="video-con-l fl por">
						<img src="../assets/images/player.png" alt="" class="player poa"/>
						<img :src="downloadUrl+videoL.photo_big" alt="" class="pic" />
						<div class="video-con-l-con poa">
							<p
								class="fl name txt-overflow"
								:title="videoL.title"
							>
								{{videoL.title}}
							</p>
							<p class="fr time">{{videoL.total_hours}}</p>
						</div>
					</router-link>
					<div class="video-con-r fr">
						<el-carousel
							:interval="5000"
							arrow="always"
							indicator-position="none"
							:autoplay="false"
						>
							<!-- <el-carousel-item v-for="item in 4" :key="item">
								<h3>{{ item }}</h3>
							</el-carousel-item> -->
							<el-carousel-item>
								<ul class="carousel">
									<li :class="['carousel-item','clearfix',{cur:item.id==cur}]" v-for="(item,index) in videoData.slice(0,4)" :key="index" @click="videoFun(item.id,item.title,item.total_hours,item.photo_big)">
										<img
											:src="downloadUrl+item.photo"
											alt=""
											class="fl"
										/>
										<div class="carousel-item-r fr">
											<p class="p1">
												{{item.title}}
											</p>
											<p class="p2">
												<span>主讲人: {{item.speaker__name}}</span
												><span>主办单位：{{item.host_unit}}</span>
											</p>
										</div>
									</li>
								</ul>
							</el-carousel-item>
							<el-carousel-item>
								<ul class="carousel">
									<li :class="['carousel-item','clearfix',{cur:item.id==cur}]" v-for="(item,index) in videoData.slice(4,8)" :key="index" @click="videoFun(item.id,item.title,item.total_hours,item.photo_big)">
										<img
											:src="downloadUrl+item.photo"
											alt=""
											class="fl"
										/>
										<div class="carousel-item-r fr">
											<p class="p1">
												{{item.title}}
											</p>
											<p class="p2">
												<span>主讲人: {{item.speaker__name}}</span
												><span>主办单位：{{item.host_unit}}</span>
											</p>
										</div>
									</li>
								</ul>
							</el-carousel-item>
							<el-carousel-item>
								<ul class="carousel">
									<li :class="['carousel-item','clearfix',{cur:item.id==cur}]" v-for="(item,index) in videoData.slice(8,12)" :key="index" @click="videoFun(item.id,item.title,item.total_hours,item.photo_big)">
										<img
											:src="downloadUrl+item.photo"
											alt=""
											class="fl"
										/>
										<div class="carousel-item-r fr">
											<p class="p1">
												{{item.title}}
											</p>
											<p class="p2">
												<span>主讲人: {{item.speaker__name}}</span
												><span>主办单位：{{item.host_unit}}</span>
											</p>
										</div>
									</li>
								</ul>
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
				<div class="video-con-detail clearfix">
					<div class="video-con-detail-l fl">
						<!-- <p class="brief" :title="videoDetailData.brief">
							<span>视频简介：</span
							>{{curStr(videoDetailData.brief,180)}}
						</p> -->
						<p class="brief brief-con">
							<span>视频简介：</span>
							<el-tooltip class="item" effect="light" :content="videoDetailData.brief" placement="bottom">
								<el-button>{{curStr(videoDetailData.brief,146)}}</el-button>
							</el-tooltip>
						</p>
						<h3><span>拓展阅读</span></h3>
						<ol class="gx_l_data" v-if="videoDetailData.reading">
							<li v-for="(item,index) in videoDetailData.reading[0]" :key="index">
								<!-- 网站版 -->
								<a
									:href="urlPath+'kcms/detail?dbcode='+ item.source_code +'&dbname='+item.table_name+'&filename='+item.file_name+'&pcode='+item.table_name.substring(0,4)+'&'"
									target="_blank"
									:title="item.title"
									v-if="isWeb=='yes'"
									>{{item.title}}</a
								>
								<!-- 镜像版 dbcode=ZYDT_ -->
								<a
									:href="urlPath+'KCMS/detail/detail.aspx?dbcode=ZYDT_'+item.table_name.substring(0,4)+'&dbname='+item.table_name+'&filename='+item.file_name+'&'"
									target="_blank"
									:title="item.title"
									v-if="isWeb=='no'"
									>{{item.title}}</a
								>
								<span class="text-ellipsis" :title="cutAuthorFun(item.author)">{{cutAuthorFun(item.author)}}</span>
							</li>
						</ol>
					</div>
					<div class="video-con-detail-l video-con-detail-r fr">
						<p class="brief"><span>主办单位：</span>{{videoDetailData.host_unit}}</p>
						<p class="brief"><span>主讲人：</span>{{videoDetailData.speaker__name}}</p>
						<p class="brief brief-con">
							<el-tooltip class="item" effect="light" :content="videoDetailData.speaker__brief" placement="bottom">
								<el-button>{{curStr(videoDetailData.speaker__brief,110)}}</el-button>
							</el-tooltip>
						</p>
						<h3><span>专家成果</span></h3>
						<ol class="gx_l_data">
							<li v-for="(item,index) in videoDetailData.expert_pro" :key="index">
								<!-- 网站版 -->
								<a
									:href="urlPath+'kcms/detail?dbcode='+ item.source_code+'&dbname='+item.table_name+'&filename='+item.file_name+'&pcode='+item.table_name.substring(0,4)+'&'"
									target="_blank"
									:title="item.title"
									v-if="isWeb=='yes'"
									>{{item.title}}</a
								>
								<!-- 镜像版 dbcode=ZYDT_ -->
								<a
									:href="urlPath+'KCMS/detail/detail.aspx?dbcode=ZYDT_'+item.table_name.substring(0,4)+'&dbname='+item.table_name+'&filename='+item.file_name+'&'"
									target="_blank"
									:title="item.title"
									v-if="isWeb=='no'"
									>{{item.title}}</a
								>
								<span>{{item.pub_date.substring(0,10)}}</span>
							</li>
						</ol>
					</div>
				</div>
			</div>
		</div>
		<!-- 党史期刊 -->
		<div class="journal wid-1200">
			<h2 class="title title3"></h2>
			<ul class="journal-con clearfix">
				<li v-for="(item,index) in journalData" :key="index">
					<!-- 网站版 -->
					<a :href="urlPath+item.file_path" target="_blank" v-if="isWeb=='yes'">
						<img :src="item.photo" alt="" />
						<p class="txt-overflow">{{item.title}}</p>
					</a>
					<!-- 镜像版 dbcode=ZYDT_ -->
					<a :href="urlPath+addCode(item.file_path)" target="_blank" v-if="isWeb=='no'">
						<img :src="item.photo" alt="" />
						<p class="txt-overflow">{{item.title}}</p>
					</a>
				</li>
				<!-- <li>
					<a :href="urlPath+'knavi/journal/Detail/DSZJ/DSBL?NaviID='" target="_blank">
						<img src="../assets/images/j2.jpg" alt="" />
						<p class="txt-overflow">党史博览</p>
					</a>
				</li> -->
			</ul>
		</div>
		<foot></foot>
	</div>
</template>
<script>
export default {
	components: {},
	data() {
		return {
			videoData:[],//视频课程
			downloadUrl: this.url.downloadUrl, //查看图片公共链接
			urlPath:this.url.urlPath,//链接路径
			isWeb:this.url.isWeb,//是否未网站版
			videoL:{
				id:"",//右侧-视频课程
				title:"",//右侧-图片标题
				total_hours:"",//右侧-视频时长
				photo_big:"",//右侧-图片地址
			},
			cur:1,//视频课程右侧-当前显示的id

			videoDetailData:{},//视频详情数据
			leaderHistoryData:[],//领导人谈党史
			leaderHistoryDetailData:{},//领导人谈党史-描述
			journalData:[],//党史期刊
		};
	},
	created() {
		/* //获取到localStorage里的值
		this.username = localStorage.getItem("username");
		this.userData.groupid = localStorage.getItem("groupid");
		this.userData.userid = localStorage.getItem("userid");
		this.groupid_list = JSON.parse(
			window.localStorage.getItem("groupid_list")
		); */
		this.getLeaderHistoryDetailData();//领导人谈党史-描述
		this.getLeaderHistoryData();//领导人谈党史
		this.getVideoData();//获取视频课程
		this.getVideoDetailData(1);//获取视频详情
		this.getJournalData();//党史期刊
	},
	mounted() {},
	methods: {
		//党史期刊-镜像版添加ZYDT_
		addCode(path){
			//"knavi/journal/Detail/DSZJ/ZGDS?NaviID="
			return path.replace(/DSZJ/,"ZYDT_DSZJ")
		},
		//将数据中最后面的分号去掉
		cutAuthorFun(author){
			// if(author.indexOf(';')>-1){
			// 	return author.substr(0,author.length-1);
			// }else{
			// 	return author;
			// }
			if(author.substring(author.length-1)==";"){
				return author.substr(0,author.length-1);
			}else{
				return author;
			}
		},
		//领导人谈党史-上描述
		getLeaderHistoryDetailData(){
			this.axios
				.get("/sqlite/get_leader_speech/")
				.then((res) => {
					console.log("领导人谈党史描述======");
					console.log(res);
					if (res.status == 200) {
						this.leaderHistoryDetailData = res.data[0];
					} else {
						console.log("获取领导人谈党史描述失败！");
						this.$message.error("获取领导人谈党史描述失败！");
					}
				});
		},
		//领导人谈党史
		getLeaderHistoryData(){
			this.axios
				.get("/sqlite/get_file_list/")
				.then((res) => {
					console.log("领导人谈党史======");
					console.log(res);
					if (res.status == 200) {
						this.leaderHistoryData = res.data;
					} else {
						console.log("获取领导人谈党史失败！");
						this.$message.error("获取领导人谈党史失败！");
					}
				});
		},
		//党史期刊
		getJournalData(){
			this.axios
				.get("/sqlite/get_periodical_list/")
				.then((res) => {
					console.log("党史期刊======");
					console.log(res);
					if (res.status == 200) {
						this.journalData = res.data;
					} else {
						console.log("获取党史期刊失败！");
						this.$message.error("获取党史期刊失败！");
					}
				});
		},
		//获取视频课程
		getVideoData() {
			this.axios
				.get("/sqlite/views_list/")
				.then((res) => {
					console.log("获取视频课程======");
					console.log(res);
					if (res.status == 200) {
						this.videoData = res.data;
						this.videoL.id=res.data[0].id;//右侧-视频课程id
						this.videoL.title=res.data[0].title;//右侧-图片标题
						this.videoL.total_hours=res.data[0].total_hours;//右侧-视频时长
						this.videoL.photo_big=res.data[0].photo_big;//右侧-图片地址
					} else {
						console.log("获取视频课程失败！");
						this.$message.error("获取视频课程失败！");
					}
				});
		},
		//右侧视频课程切换
		videoFun(id,title,total_hours,photo_big){
			this.videoL.id=id;
			this.videoL.title=title;
			this.videoL.total_hours=total_hours;
			this.videoL.photo_big=photo_big;
			this.cur=id;
			this.getVideoDetailData(id);//获取视频详情
		},
		//获取视频详情
		getVideoDetailData(id){
			this.axios
				.get("/sqlite/views_list_detail/"+id+"/")
				.then((res) => {
					console.log("获取视频课程详情======");
					console.log(res);
					if (res.status == 200) {
						this.videoDetailData = res.data;
					} else {
						console.log("获取视频课程详情失败！");
						this.$message.error("获取视频课程详情失败！");
					}
				});
		},
		//截取字符串
		curStr(str, len) {
			//摘要截取200字
			//此处加一层判断 防止获取不到length
			if (str) {
				//\s表示正则匹配字符串中的空字符串
				str = str.replace(/\s/g, "");
				if (str.length <= len) {
					return str;
				} else {
					return str.substring(0, len) + "..."; //substring()提取字符串介于两个指定下表之间的字符
				}
			}
		},
	},
	computed: {},
};
</script>
<style lang="scss" scoped>
.title {
	height: 58px;
	line-height: 58px;
	font-size: 30px;
}
.title1 {
	background: url("../assets/images/title1.png") center center no-repeat;
}
.title2 {
	background: url("../assets/images/title2.png") center 0 no-repeat;
}
.title3 {
	background: url("../assets/images/title3.png") center 0 no-repeat;
}
// 领导人谈党史
.leader {
	padding-top: 51px;
	padding-bottom: 57px;
	.leader-t-con {
		padding-top: 20px;
		/*width: 826px;*/
		width: 1150px;
		font-size: 16px;
		text-align: justify;
		p.con{
			line-height: 38px;
			padding-top: 25px;
			text-indent:33px;
			margin-left: 30px;
		}
		.tar{
			font-size: 14px;
			color:#666;
			padding-top: 10px;
		}
	}
	.leader-b {
		padding-top: 18px;
	}
}

.gx_l_data {
	li {
		height: 42px;
		line-height: 42px;
		float: left;
		font-size: 14px;
		width: 46%;
		margin-right: 42px;
		a {
			padding-left: 61px;
			color: #333;
			background: url("../assets/images/text-icon.png") 25px center
				no-repeat;
			width: calc(100% - 200px);
			display: block;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			float: left;
		}
		span {
			width: 86px;
			color: #666;
			float: right;
			text-align: right;
		}
		& a:hover {
			color: #f70;
		}
	}
}
// .gx_l_data li.item_more{line-height:30px;height:30px;background:none;text-align:right;}
// .gx_l_data li.item_more a{color:#d18c46;display:inline;font-size:20px;width:74px;float:none;}

// 视频课程
.video-wrap {
	background: url("../assets/images/Course-background.png") center 0 no-repeat;
	.video {
		padding-top: 30px;
		.video-con {
			padding-top: 27px;
		}
		.video-con-l {
			width: 590px;
			height: 369px;
			cursor: pointer;
			.pic {
				width: 590px;
				height: 369px;
			}
			.player{
				width: 80px;
				height: 80px;
				display:block;
				left:50%;
				margin-left: -40px;
				margin-top: -40px;
				top:50%;
			}
			.video-con-l-con {
				color: #fff;
				bottom: 0;
				height: 44px;
				line-height: 44px;
				width: 100%;
				font-weight: bold;
				background:rgba(0,0,0,0.5);
				.name {
					font-size: 20px;
					width: 80%;
					padding-left: 18px;
				}
				.time {
					font-size: 16px;
					padding-right: 9px;
				}
			}
		}
		.video-con-r {
			width: 576px;
			height: 369px;
		}
		.video-con-detail {
			padding-top: 76px;
			.video-con-detail-l {
				width: 587px;
				background-color: #fdf8f3;
				box-shadow: 0px 3px 4px 0px rgba(231, 232, 237, 0.35);
				border: solid 1px #eee;
				box-sizing: border-box;
				padding: 30px 23px 24px 18px;
				height: 372px;
				.brief {
					line-height: 28px;
					color: #666;
					font-size: 14px;
					span {
						color: #bc2221;
						font-size: 16px;
						font-weight: bold;
					}
				}
				.brief-con{
					height: 142px;
					.el-button{
						background:transparent;
						border:none;
						display:inline;
						white-space:inherit;
						line-height: 28px;
						color:#666;
						text-align: justify;
						padding:0;
						cursor:text;
					}
				}
				h3 {
					margin-top: 17px;
					height: 30px;
					line-height: 30px;
					color: #fff;
					border-bottom: dashed 1px #eac5b2;
					font-size: 16px;
					margin-bottom: 6px;
					span {
						width: 73px;
						background-color: #bc2221;
						text-align: center;
						display: inline-block;
					}
				}
				.gx_l_data {
					li {
						border-bottom: 1px dashed #dcdcdc;
						width: 100%;
						margin-right: 0;
						height: 29px;
						line-height: 29px;
						font-size: 13px;
						a {
							background: url("../assets/images/arrow-small.png")
								4px center no-repeat;
							padding-left: 19px;
							// width: 92%;
						}
						span{
							width: 120px;
						}
					}
				}
			}
			.video-con-detail-r {
				.gx_l_data {
					li {
						a {
							width: calc(100% - 160px);
						}
					}
				}
				.brief-con{
					height: 84px;
				}
			}
		}
	}
}
//视频课程轮播
.video-con-r /deep/ {
	.el-carousel__container {
		height: 369px;
	}
	.el-carousel__item .carousel {
		width: 522px;
		margin: 0 auto;
		li {
			cursor: pointer;
			margin-bottom: 8px;
			// transition: transform .3s;
			// &:hover{
			// 	transform:scale(1.1);
			// }
			img {
				width: 181px;
				height: 85px;
				display: block;
			}
			&.cur{
				p{
					color:#900!important;
				}
			}
		}
		.carousel-item-r {
			width: 312px;
			height: 85px;
			background: #fef7f9;
			box-shadow: 0px 3px 4px 0px rgba(231, 232, 237, 0.35);
			box-sizing: border-box;
			padding: 14px 0 0 11px;
			line-height: 28px;
			.p1 {
				font-size: 14px;
				color: #333;
			}
			.p2 {
				font-size: 12px;
				color: #666;
				span:nth-child(1){
					margin-right: 13px;
				}
			}
		}
	}
	.el-carousel__arrow--left {
		left: 0;
		background: url("../assets/images/arrow-left.png") 0 center no-repeat;
		width: 20px;
		i {
			display: none;
		}
		&:hover {
			background: url("../assets/images/arrow-left.png") 0 center
				no-repeat;
		}
	}
	.el-carousel__arrow--right {
		right: 0;
		background: url("../assets/images/arrow-right.png") right center
			no-repeat;
		width: 20px;
		i {
			display: none;
		}
		&:hover {
			background: url("../assets/images/arrow-right.png") right center
				no-repeat;
		}
	}
}

// 党史期刊
.journal {
	padding-top: 65px;
	padding-bottom: 45px;
	.journal-con {
		padding-top: 27px;
		li {
			float: left;
			width: 240px;
			a {
				width: 209px;
				margin: 0 auto;
				display: block;
				img {
					width: 209px;
					height: 286px;
				}
				p {
					line-height: 32px;
					font-size: 16px;
					color: #333;
					text-align: center;
					margin-top: 14px;
				}
				&:hover p {
					color: #f70;
				}
			}
		}
	}
}

</style>
